import React, { createContext, ReactNode, useCallback, useContext, useState } from "react";
import { qdtComponents } from "../config/globalApp";

type appContextType = {
  showFilter: boolean;
  toggleShowFilter: () => void;
  clearAllSelections: () => void;
  goToTop: () => void;
};

const appDefaultValues: appContextType = {
  toggleShowFilter: () => {},
  clearAllSelections: () => {},
  goToTop: () => {},
  showFilter: false
};

const AppContext = createContext<appContextType>(appDefaultValues);

export function useApp() {
  return useContext(AppContext)
}

type Props = {
  children: ReactNode;
};

export function AppProvider({children}: Props) {
  const [showFilter, setShowFilter] = useState(false);
  
  const toggleShowFilter = () => {
    setShowFilter(!showFilter)
  }

  const clearAllSelections = async () => {
    const qApp = await qdtComponents.qAppPromise;
    await qApp?.clearAll();
  }

  const goToTop =  useCallback(() => {
    window?.scrollTo({top: 0, behavior: 'smooth'});
  }, [])

  const value = {
    toggleShowFilter,
    showFilter,
    goToTop,
    clearAllSelections
  }

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  )
}
